import {useSearchParams} from 'react-router-dom';

import {useTheme} from '@mui/material/styles';
import {Typography} from '@mui/material';

import {Ellipse, Page} from '../../../components';
import {LoginForm as Form} from './Form';
import {EllipseSize as Size, Position} from '../../../types/generics';

export const Login = () => {
  const theme = useTheme();

  const [searchParams] = useSearchParams();
  const to = searchParams.get('to');

  return (
    <Page>
      <Ellipse
        backgroundColor={theme.palette.secondary.main}
        bounds={{
          maxHeight: 150,
          paddingTop: 150,
          position: Position.BOTTOM_CENTER,
        }}
        height={300}
        size={Size.TOP_HALF}
        width={700}
      />

      <div className="flex items-center min-h-[80vh] z-10">
        <div className="grid justify-center bg-card-main rounded-2xl">
          <div className="flex flex-col items-center py-10 px-7 w-full gap-2">
            <Typography variant="h3">Log in to continue</Typography>
            {to && <div className="text-secondary-light">You need to log in to access the page you requested.</div>}
            <hr className="w-full h-[2px] mx-auto mt-4 bg-slate-800 border-0 rounded-sm  dark:bg-slate-400" />
            <Form />
            <div className="flex flex-col items-center">
              <Typography variant="h6_grey">
                Don't have an account?{' '}
                <a className="purple-link" href="/register">
                  Register
                </a>
              </Typography>
              <br />
              <Typography variant="h6_grey">
                Forgot your password?{' '}
                <a className="purple-link" href="/reset-password">
                  Reset Password
                </a>
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};
